var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"buttonPrimary",class:{'button--disable': !_vm.savable},on:{"click":_vm.save}},[_vm._v("SAVE")])])}
var staticRenderFns = []

export { render, staticRenderFns }